import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const InvoiceChart = ({ chartData }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false, // 👈 important
    plugins: {
      legend: {
        display: true,
        labels: {
          boxWidth: 12,
        },
      },
    },
    elements: {
      line: {
        tension: 0.4,
        borderWidth: 2,
      },
      point: {
        radius: 3,
      },
    },
    scales: {
      y: {
        grid: {
          color: "#eee",
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div
      className="card border-0 mt-2 w-100"
      style={{
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
        padding: "15px",
        
      }}
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 style={{ fontWeight: 600 }}>Expense</h6>

        <select
          style={{
            borderRadius: "8px",
            padding: "4px 8px",
            border: "1px solid #ddd",
      
          }}
        >
          <option>This Year</option>
        </select>
      </div>

      {/* CHART HEIGHT CONTROL */}
      <div style={{ height: "350px" }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default InvoiceChart;